export default "__VITE_ASSET__yBIrhd9F__"